import { useQuery } from '@tanstack/react-query'

import { getGuaranteeMoneyBalanceHistory } from '@src/api'
import { DefaultApiGetGuaranteeMoneyBalanceHistoryRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks/use-axios'

export const useFetchGuaranteeMoneyBalanceHistory = (
  params: DefaultApiGetGuaranteeMoneyBalanceHistoryRequest
) => {
  const { axiosInstance } = useAxios()
  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getGuaranteeMoneyBalanceHistory(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_GUARANTEE_MONEY_BALANCE_HISTORY],
  })
}
